(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-additions-components/assets/javascripts/bet-amounts.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-additions-components/assets/javascripts/bet-amounts.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useCallback = _React.useCallback;
const ReactIcon = svs.ui.ReactIcon;
const format = svs.utils.format;
const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  RadioButton = _svs$ui$reactForm.RadioButton,
  Fieldset = _svs$ui$reactForm.Fieldset,
  Form = _svs$ui$reactForm.Form,
  Inputv2 = _svs$ui$reactForm.Inputv2;
const actions = svs.components.tipsen.engine.actions;
const selectBetAmounts = svs.components.tipsen.engine.selectors.engineSelectors.selectBetAmounts;
const selectCurrentBetAmount = svs.components.tipsen.engine.selectors.couponSelectors.selectCurrentBetAmount;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const selectEngineDefinition = svs.components.tipsen.engine.selectors.selectEngineDefinition;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const BaseAddons = svs.components.tipsen.baseAddons.BaseAddons;


function restArguments(func, startIndex) {
  startIndex = startIndex === undefined || startIndex === null ? func.length - 1 : +Number(startIndex);
  return function () {
    const length = Math.max(arguments.length - startIndex, 0);
    const rest = Array(length);
    let index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0:
        return func.call(this, rest);
      case 1:
        return func.call(this, arguments[0], rest);
      case 2:
        return func.call(this, arguments[0], arguments[1], rest);
    }
    const args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
}
function debounce(func, wait, immediate) {
  let timeout;
  let previous;
  let args;
  let result;
  let context;
  const later = function () {
    const passed = Date.now() - previous;
    if (wait > passed) {
      timeout = setTimeout(later, wait - passed);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
      }
      if (!timeout) {
        args = context = null;
      }
    }
  };
  const debounced = restArguments(function (_args) {
    context = this;
    args = _args;
    previous = Date.now();
    if (!timeout) {
      timeout = setTimeout(later, wait);
      if (immediate) {
        result = func.apply(context, args);
      }
    }
    return result;
  });
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = args = context = null;
  };
  return debounced;
}


const BetAmounts = () => {
  const dispatch = useDispatch();
  const couponId = useCouponId();
  const betAmounts = useSelector(selectBetAmounts);
  const currentBetAmount = useSelector(state => selectCurrentBetAmount(state, couponId));
  const oldBetAmount = useRef(currentBetAmount);
  const engineDefinition = useSelector(selectEngineDefinition);
  const maxBetAmount = engineDefinition.maxBetAmount;
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const _useState = useState(currentBetAmount),
    _useState2 = _slicedToArray(_useState, 2),
    betAmountInput = _useState2[0],
    setBetAmountInput = _useState2[1];
  const minBetAmount = betAmounts[0];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasErrors = _useState4[0],
    setHasErrors = _useState4[1];

  useEffect(() => {
    if (oldBetAmount.current !== currentBetAmount) {
      oldBetAmount.current = currentBetAmount;
      setBetAmountInput(currentBetAmount);
    }
  }, [currentBetAmount]);
  const _useState5 = useState({
      error: false,
      message: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    betAmountErrors = _useState6[0],
    setBetAmountErrors = _useState6[1];
  const setError = useCallback(message => {
    setBetAmountErrors({
      error: true,
      message
    });
  }, []);
  const removeError = () => {
    setBetAmountErrors({
      error: false,
      message: ''
    });
  };
  const debouncer = useRef();
  useEffect(() => {
    debouncer.current = debounce(value => {
      if (value < minBetAmount || value > maxBetAmount) {
        setError("V\xE4lj ett belopp mellan ".concat(minBetAmount, " och ").concat(maxBetAmount, " kr"));
      }
    }, 500);
    return () => {
      debouncer.current.cancel();
    };
  }, [setError, maxBetAmount, minBetAmount]);
  const handleChange = e => {
    setHasErrors(false);
    const input = e.target.value.replace(/[^0-9]/g, '');
    const value = Number(input);
    const rangeIsOk = value > 0 && value >= minBetAmount && value <= maxBetAmount;
    if (!Number.isNaN(value) && value) {
      debouncer.current(value);
    }
    if (!value || value.length === 0 || rangeIsOk) {
      removeError();
      debouncer.current.cancel();
    }
    if (value) {
      dispatch(actions.selectBetAmount({
        couponId,
        betAmount: value
      }));
    }
    setBetAmountInput(value ? value : '');
  };
  const handleSubmit = betAmount => {
    setBetAmountInput(betAmount);
    dispatch(actions.selectBetAmount({
      couponId,
      betAmount
    }));
  };
  const handleOnBlur = () => {
    setHasErrors(betAmountErrors.error);
  };
  return React.createElement(BaseAddons, {
    icon: "money",
    id: "betamount",
    title: "Insats per rad"
  }, React.createElement("div", {
    className: "tipsen-addition-bet-amount"
  }, React.createElement("div", null, React.createElement("div", {
    className: "bet-amount-desc"
  }, betAmounts.map((amount, index) => index ? React.createElement("div", {
    className: "pg_tipsen_bet_amount_desc__item",
    key: amount
  }, React.createElement("span", null, "".concat(amount, " x")), React.createElement("span", null, "vinst")) : null)), React.createElement(Form, {
    className: "tipsen-addition-form"
  }, React.createElement(Fieldset, null, React.createElement("legend", {
    className: "sr-only"
  }, "Insats per rad"), React.createElement(ControlGroup, null, React.createElement(RadioGroup, {
    size: "200"
  }, betAmounts.map(betAmount => {
    const checked = betAmount === currentBetAmount;
    return React.createElement(RadioButton, {
      "aria-checked": checked,
      checked: checked,
      className: checked ? 'f-bold' : '',
      key: betAmount,
      onChange: () => handleSubmit(betAmount),
      tabIndex: checked ? 0 : -1,
      value: betAmount
    }, format.Currency(betAmount), ' ', "kr");
  })))))), maxBetAmount > 0 && React.createElement(Form, {
    className: "tipsen-addition-bet-amount__input",
    isVertical: true,
    onSubmit: e => e.preventDefault()
  }, React.createElement(ControlGroup, {
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    "aria-describedby": "tipsenAdditionBetAmountInputErrortext",
    "aria-invalid": hasErrors,
    id: "betAmountInput",
    inputHelpText: isSmallDevice ? 'Insats' : 'Välj egen insats',
    label: isSmallDevice ? 'Insats' : 'Välj egen insats',
    min: "0",
    onBlur: handleOnBlur,
    onChange: handleChange,
    suffix: "kr",
    type: "tel",
    value: betAmountInput
  })))), React.createElement("div", {
    className: "tipsen-addition-bet-amount__input-error"
  }, betAmountErrors.error && React.createElement(ReactIcon, {
    color: "fc-red",
    icon: "help-2",
    size: "300"
  }), betAmountErrors.message), React.createElement("div", {
    "aria-live": "assertive",
    className: "sr-only",
    id: "tipsenAdditionBetAmountInputErrortext"
  }, hasErrors && React.createElement("span", null, betAmountErrors.message)));
};
setGlobal('svs.components.tipsen.couponAdditionsComponents.BetAmounts', BetAmounts);

 })(window);